// Purpose: Route vendor invitations into the shared business verification form.
// Dependencies: Scoped vendor credentials and BusinessVerification.
// Behavior: Display vendor terms and public edits with ordinary optional account signup.
import React from "react";
import BusinessVerification from "../../components/business_verification";
import { getVendorVerificationInvite } from "../../utils/vendor_verification_invite";

export default function VendorVerification() {
  return <BusinessVerification family="vendor" getInvite={getVendorVerificationInvite} />;
}
